import React from 'react';
//import {MovieCastData} from './MovieCastData.js';
import MovieCastData from './MovieCastData.js';
//import {MovieCastDataFetch} from './MovieCastDataFetch.js';

const MovieCastMaster = props => {
  //const {MovieCastData, loading, error} = MovieCastDataFetch();
  //console.log(MovieCastData);
  //if (loading) return <div>Loading...</div>;
  //if (error) return <div>{error}</div>;

  //const handleClick = (id) => {
  //  console.log("ID: " + id);
    //props.personId = useState(id);
  //}

  return (
    <ul>
      {MovieCastData.map(person => (
        <li key={person.id} onClick={() => props.setPersonId(person.id)}> {/*props.setPersonId(person.id)}>   handleClick(person.id)}>*/}
        <img src={"https://www.marchouben.nl/afbeeldingen/" + person.profile_path} alt="" height="100"/>
        <h1>{person.name}</h1>
        <h3>{person.description}</h3>
        <h1>{person.id}</h1>
      </li>
      ))} 
    </ul>
);
};
export default MovieCastMaster;